import React from 'react';
import styles from './index.less';

const MessagePremiumAppointment = props => {
  const { data = {} } = props;

  const { content = {} } = data;

  const { title_image, title, sub_title } = content;

  return (
    <div className={styles.card}>
      {title_image && <img src={title_image} alt='' className={styles.image} />}
      <div className={styles.info}>
        <h2 className={styles.title}>{title}</h2>
        {sub_title && <p className={styles['sub-title']}>{sub_title}</p>}
      </div>
    </div>
  );
};

export default MessagePremiumAppointment;
